import type { Marker, MarkerFormatter, Rectangle } from '@sembo-private/maps';

export interface MapConfig {
  markers?: Marker;
  markerFormatters?: Partial<MarkerFormatter>;
  startRectangle?: Rectangle;
}

export enum MapType {
  Static = 'StaticMap',
  Dynamic = 'DynamicMap',
}
